// src/context/MyContext.js

import React, { useState, useEffect } from "react";

const MyContext = React.createContext();

// ── FIXED: pehle baseUrl sirf MyContextProvider ke andar tha, is liye
// AuthRefresh.js (jo React component nahi hai) usay seedha import nahi
// kar sakti thi — isi liye wahan dobara alag se maintain karna parta
// tha. Ab ye component ke bahar, top-level "export const" hai — dono
// jagah (yahan ka Provider bhi, aur AuthRefresh.js bhi) isi ek jagah
// se baseUrl lete hain. Production pe jaate waqt sirf yahan badalna hai.
// export const baseUrl = "http://127.0.0.1:8000/api";
// export const baseUrlForFiles = "http://127.0.0.1:8000/storage";
export const baseUrl = "https://kisaanmart.btsportfolio2026.com/backend/public/api";
export const baseUrlForFiles = "https://kisaanmart.btsportfolio2026.com/backend/public/storage";

export const MyContextProvider = ({ children }) => {
  /** ------------------ AUTH TOKEN ------------------ **/
  const [authToken, setAuthToken] = useState(localStorage.getItem("authToken"));
  const [isLoggedIn, setIsLoggedIn] = useState(
    localStorage.getItem("authToken") ? true : false,
  );

  /** ------------------ API URLS ------------------ **/
  const [loggedInCustomer, setLoggedInCustomer] = useState();
  const [loggedInSeller, setLoggedInSeller] = useState();
  const [loggedInAdmin, setLoggedInAdmin] = useState();
  const [loggedInDeliveryMan, setLoggedInDeliveryMan] = useState();
  const [selectedBlog, setSelectedBlog] = useState();
  const [selectedProduct, setSelectedProduct] = useState();
  const [selectedOrder, setSelectedOrder] = useState();
  const [selectedShop, setSelectedShop] = useState();
  const [cartProducts, setCartProducts] = useState([]);
  /** ------------------ VALIDATION ------------------ **/
  const usernameRegExp = /^[A-Za-z\s]{3,}$/;
  const emailRegExp = /^[A-Za-z0-9#$%_!&.?]{5,}@[a-z0-9]{3,}\.[a-z0-9.]{2,}$/;
  const passwordRegExp = /^[A-Za-z0-9#@$%^&_!.?]{8,}$/;
  const phoneNumberRegExp = /^[0-9]{4}-[0-9]{7}$/;
  const CNICnumberRegExp = /^[0-9]{5}-[0-9]{7}-[0-9]{1}$/;

  const regExpChecker = (type, input) => {
    switch (type) {
      case "username":
        if (!usernameRegExp.test(input)) {
          return "Username must be at least 3 characters";
        }
        break;
      case "email":
        if (!emailRegExp.test(input)) {
          return "Email must be in the format: john1233@example.com";
        }
        break;
      case "password":
        if (!passwordRegExp.test(input)) {
          return "Password must be 8+ characters and can include letters, numbers, and #@$%^&_!.?";
        }
        break;
      case "phoneNumber":
        if (!phoneNumberRegExp.test(input)) {
          return "Must be in this Format: 0300-1234567";
        }
        break;
      case "CNICnumber":
        if (!CNICnumberRegExp.test(input)) {
          return "Must be in this Format: 12345-1234567-1";
        }
        break;
      default:
        return null;
    }
  };

  return (
    <MyContext.Provider
      value={{
        /** AUTH **/
        authToken,
        setAuthToken,
        isLoggedIn,
        setIsLoggedIn,

        /** API **/
        baseUrl,
        baseUrlForFiles,

        /** VALIDATION **/
        regExpChecker,
        setLoggedInCustomer,
        loggedInCustomer,
        setLoggedInSeller,
        loggedInSeller,
        loggedInAdmin,
        setLoggedInAdmin,
        setSelectedBlog,
        selectedBlog,
        setSelectedProduct,
        selectedProduct,
        setSelectedOrder,
        selectedOrder,
        setSelectedShop,
        selectedShop,
        setCartProducts,
        cartProducts,

        loggedInDeliveryMan,
        setLoggedInDeliveryMan,
      }}
    >
      {children}
    </MyContext.Provider>
  );
};

export default MyContext;
